<template>
 
        <v-card  class="pb-80 event-details" elevation=0 >
            <v-system-bar
                flat
                color="transparent"
                fixed
                height="40"
                class="pt-3"
            >
      
      
                
      
                <v-btn href="../events" fab small color="primary" >
                    <v-icon class="white--text ">mdi-arrow-left</v-icon>
                </v-btn>
      
            </v-system-bar>
            <v-card-title class="pa-0 ">
              
               
              
                <v-img  :src="(event.image=='null' || event.image==null )?bannerImg:event.image" aspect-ratio="1" class="lighten-2 " max-height="287">
                   
                    <v-row class="fill-height align-start pt-81" style="background:rgba(0,0,0, 0.4);">
                        <v-col cols="12" md="12" sm="12" class=" white--text pl-30">
                            <!-- <div class="mb-10">
                               
                                <router-link to="../events">
                                    <v-icon class="white--text" >mdi-arrow-left</v-icon>
                                </router-link>
                        
                            </div> -->
                            <div class="subtitle-1  grey--text text--lighten-5">{{event.eventcategoryname}}</div>
                            <div class="headline font-weight-bold">{{event.title}}</div>
                            <span class="subtitle-1 font-weight-light">{{event.subtitle}}</span>

                                    
                        </v-col>
                                
                    </v-row>
                           
                </v-img>
                        
                    
            </v-card-title>
            <v-card-text class="mb-auto  " :class="{'pwa-content pb-90':(event.fulldate!=null && event.fulldate!='null' && event.fulldate!='') || (event.eventtime!=null && event.eventtime!='null' && event.eventtime!='') || (event.venue!=null && event.venue!='null' && event.venue!='')}">
                <v-card v-if="(event.fulldate!=null && event.fulldate!='null' && event.fulldate!='') || (event.eventtime!=null && event.eventtime!='null' && event.eventtime!='') || (event.venue!=null && event.venue!='null' && event.venue!='')">
                    <v-row class="pl-3">
                        <v-col cols="4" md="4" sm="4" class="back" align="center" justify="center" v-if="(event.fulldate!=null && event.fulldate!='null' && event.fulldate!='')">
                            <div class="fill-height d-flex align-center">
                                <div class="w-100">
                                    <div class="eventdateshow w-100"><span v-if="event.startDat!=''">{{event.startDat}}</span> <span v-if="event.endDat!=''">- {{event.endDat}}</span></div>
                                    <div class="eventdateshow w-100"><span v-if="event.startDayName!=''">{{event.startDayName}}</span> <span v-if="event.endDayName!=''">- {{event.endDayName}}</span></div>
                                </div>    
                            </div>
                        </v-col>
                        <v-col cols="8" md="8" sm="8" class="pt-0">
                            <v-row v-if="(event.fulldate!=null && event.fulldate!='null' && event.fulldate!='') || (event.eventtime!=null && event.eventtime!='null' && event.eventtime!='')">
                                <v-col cols="2" md="2" sm="2" class="pb-0 pl-1">
                                    <v-icon>mdi-clock</v-icon>
                                </v-col>
                                <v-col cols="10" md="10" sm="10" class="pb-0 pl-0">
                                    <div class=""  v-if="(event.fulldate!=null && event.fulldate!='null' && event.fulldate!='')">{{event.fulldate}}</div>  
                                    <div class="" v-if="(event.eventtime!=null && event.eventtime!='null' && event.eventtime!='')">{{event.eventtime}}</div>    
                                </v-col>
                            </v-row>

                            <v-row v-if="(event.venue!=null && event.venue!='null' && event.venue!='') ">
                                <v-col cols="2" md="2" sm="2" class="pt-0 pb-0 pl-1">
                                    <v-icon>mdi-map-marker</v-icon>
                                </v-col>
                                <v-col cols="10" md="10" sm="10" class="pt-0 pb-0 pl-0">
                                    <div class="">{{event.venue}}</div>  
                                       
                                </v-col>
                            </v-row>
                            
                        </v-col>
                    </v-row>
                </v-card>

                <v-row>
                    <!-- <v-col cols="12" md="12" sm="12" class="title font-weight-bold">Price</v-col> -->

                    <v-col cols="12" md="12" sm="12" class="pt-0" v-if="event.prices.length>0">
                        <v-row >
                            <v-col cols="4" md="4" sm="4" v-for="(item, index) in event.prices" :key="index">
                                <div>{{item.pricename}}</div>
                                <div class="txt-orange "><i class="fa" :class="event.currency"></i>  <span class="ml-1 font-weight-bold">{{item.pricevalue}}</span></div>
                            </v-col>
                        </v-row>    
                    </v-col>

                    <v-col cols="12" md="12" sm="12" class="pt-0 " v-if="event.bookingtext!='' && event.bookingtext!='null' && event.bookingtext!=null " id="booking-container" >
                        <v-btn color="#ef5000" dark :href="event.bookingurl" class="white--text">{{event.bookingtext}}</v-btn>
                    </v-col>

                    <!-- <v-col cols="12" md="12" sm="12" class="pt-0" v-if="event.pricedescription!=null && event.pricedescription!='null' && event.pricedescription!=''">
                        Includes
                    </v-col> -->

                    <!-- <v-col cols="12" md="12" sm="12" class="pt-0" v-if="!longpricedesc"  v-html="event.shortpricedesc"></v-col>

                    <v-col cols="12" md="12" sm="12" class="pt-0 pb-0" v-if="!longpricedesc">
                        <a @click="longpricedesc=!longpricedesc" class="btn-read-more">Read More</a>
                    </v-col> -->

                    <v-col cols="12" md="12" sm="12" class="pt-0" v-if="event.pricedescription!=null && event.pricedescription!='null' && event.pricedescription!=''" v-html="event.pricedescription"></v-col>

                    <!-- <v-col cols="12" md="12" sm="12" class="pt-0 pb-0" v-if="longpricedesc">
                        <a @click="longpricedesc=!longpricedesc" class="btn-read-more">Show Less</a>
                    </v-col> -->

                </v-row>

                <v-row>
                    <!-- <v-col cols="12" md="12" sm="12" class="title font-weight-bold" v-if="event.description!=null && event.description!='null' && event.description!=''">Description</v-col> -->

                    
                    <v-col cols="12" md="12" sm="12" class="pt-0 pb-3" :class="{shortdesc:!longdesc}" v-html="event.description " v-if="event.description!=null && event.description!='null' && event.description!=''"></v-col>    
                    <v-col cols="12" md="12" sm="12" class=" pb-0" v-if="event.description!=null && event.description!='null' && event.description!=''">
                        <a @click="longdesc=!longdesc" class="btn-read-more"><span  v-if="longdesc">Show Less</span><span  v-if="!longdesc">Read More</span></a>
                    </v-col>    
                </v-row>    

                <v-row v-if="event.eventgallery.length>0">
                    <v-col cols="12" md="12" sm="12" class="title font-weight-bold">Gallery</v-col>
                </v-row>        

                <v-row v-if="event.eventgallery.length>0">
                    <v-col cols="4" sm="4" md="4" v-for="(item, index) in event.eventgallery" :key="index" class="mb-1 pa-0 pr-1 " >
                        
                               <v-img :src="item.imageurl" width="150" height="150" class="mr-1" @click="openslideshow(index)"></v-img>
                            
                    </v-col>
                </v-row>
                <v-dialog
                    v-model="dialog"
                    max-width="100%">
                        <v-carousel hide-delimiters>
                                <v-carousel-item
                                v-for="(item,i) in items"
                                :key="i"
                                :src="item.src"
                            ></v-carousel-item>
                        </v-carousel>
                </v-dialog>

            </v-card-text>
        </v-card>
        
</template>

<script>
    import Vue from 'vue'
    import { EventBus } from '@/event-bus';
    

    export default {
        props:['event'],
        data: () => 
        ({
            bannerImg:require('@/assets/overview-banner.jpg'),
            //bannerImg:'',
            logoImg:require('@/assets/logo.svg'),
            loading:false,
            isUsed: false,
            search: null,
            valid: true,
            isAgent: false,
            isSameUser:false,
            business_id: 0,
            businesses: [],
            storeBusiness: [],
            tagBusiness: {},
            code:0,
            starrating:0,
            longdesc:false,
            longpricedesc:false,
            //activeBtn: 1,
            data:[],
            eventcategories:[],
            eventtype_id:0,
            event_id:0,
            eventtypes:[],
           
            prices:[],
            eventgallery:[],
            business_id: 0,
            currencyicon:'',
            current_businessid:0,
            offsetTop:0,
            fixed:false,
            eltop:0,
            items:[],
            dialog:false,
            model:0,
        }),
        mounted(){
            //this.eltop=document.getElementById('booking-container').offsetTop;
        },
        destroyed () 
        {
            // window.removeEventListener('scroll', this.onScroll);
        },
        created()
        {
            
            
        },
        watch:{
            event:function(value)
            {
                return value;
            },
            
        },
        methods:
        {
            
        //     onScroll (e) {
             
        //     this.offsetTop = e.target.scrollingElement.scrollTop;
        //    // let eltop=document.getElementById('booking-container').offsetTop;
        //    //console.log('offset '+this.offsetTop+' elementtop '+eltop);
        //     if(this.offsetTop>=this.eltop)
        //     {
        //         this.fixed=true;
        //     }else{
        //         this.fixed=false;
        //     }

        //    // console.log(this.offsetTop);
        // },
            
            juzzap()
            {
                this.$router.push({name:'tagsnew',params:{code:  'juzzap'}});
            },

            openslideshow(index)
            {
                
                this.items=[];
                this.model=index;
               console.log(index)
               var evtgal=this.event.eventgallerylarge;
               for (var i=0;i<evtgal.length;i++){
                   this.items.push({'src':evtgal[i].imageurl});
               }
               this.dialog=true;
            }


        }
    }
</script>
<style scope>
.event-details .v-slide-group__prev {
    display: none;
}
.event-details .v-slide-group__next{
    display: none;
}
.txt-orange{
    color: #FE5800;
}
.back{
    background: #FE5800;
}
.eventdateshow{
    
    
    background: #FE5800;
    color: #fff;
    font-size: 18px;
    
}
.mb-10{
    margin-bottom: 5rem;
}
.mb-35
{
    margin-bottom: 35px;
}
.pte-15{
    padding-top:3rem !important;
}
.pwa-content{
    margin-top: -46px;
}
.f-btn .v-btn__content
{
    -webkit-box-orient: vertical;

-webkit-box-direction: reverse;

-ms-flex-direction: column-reverse;

flex-direction: column-reverse;
}
.mt-60-n{
    margin-top:-60px;
}
.pb-80{
    padding-bottom: 80px;
}
.v-card__title{
    word-break: normal;
}
.align-cnt
{
    text-align: center;
}
.btn-read-more,.v-application a.btn-read-more{
    padding: 5px;
    background: #ef5000;
    color: #fff !important;
    border-radius: 4px;
    margin-bottom: 1rem;
}
.isfixed{
    position: fixed;
    top:0px;
    left:0px;
    background: rgba(0,0,0,0.5);
    
}
.v-application .pt-0.isfixed{
    padding-top: 15px !important;
}
.longdesc
{
    height: auto;
}
.shortdesc
{
    height:150px;
    overflow:hidden;
}
.pt-81{
    padding-top: 3rem !important;
}

</style>